// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationStatus = exports.WarningType = exports.ErrorType = void 0;
/**
 * An enum that represents the types of errors that can occur during validation.
 */
var ErrorType;
(function (ErrorType) {
    ErrorType["SpecNotValid"] = "spec-not-valid";
    ErrorType["RemoteRefNotSupported"] = "remote-ref-not-supported";
    ErrorType["NoServerInformation"] = "no-server-information";
    ErrorType["UrlProtocolNotSupported"] = "url-protocol-not-supported";
    ErrorType["RelativeServerUrlNotSupported"] = "relative-server-url-not-supported";
    ErrorType["NoSupportedApi"] = "no-supported-api";
    ErrorType["NoExtraAPICanBeAdded"] = "no-extra-api-can-be-added";
    ErrorType["ResolveServerUrlFailed"] = "resolve-server-url-failed";
    ErrorType["SwaggerNotSupported"] = "swagger-not-supported";
    ErrorType["MultipleAPIKeyNotSupported"] = "multiple-api-key-not-supported";
    ErrorType["ListFailed"] = "list-failed";
    ErrorType["listSupportedAPIInfoFailed"] = "list-supported-api-info-failed";
    ErrorType["FilterSpecFailed"] = "filter-spec-failed";
    ErrorType["UpdateManifestFailed"] = "update-manifest-failed";
    ErrorType["GenerateAdaptiveCardFailed"] = "generate-adaptive-card-failed";
    ErrorType["GenerateFailed"] = "generate-failed";
    ErrorType["ValidateFailed"] = "validate-failed";
    ErrorType["Cancelled"] = "cancelled";
    ErrorType["Unknown"] = "unknown";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
/**
 * An enum that represents the types of warnings that can occur during validation.
 */
var WarningType;
(function (WarningType) {
    WarningType["OperationIdMissing"] = "operationid-missing";
    WarningType["GenerateCardFailed"] = "generate-card-failed";
    WarningType["OperationOnlyContainsOptionalParam"] = "operation-only-contains-optional-param";
    WarningType["ConvertSwaggerToOpenAPI"] = "convert-swagger-to-openapi";
    WarningType["Unknown"] = "unknown";
})(WarningType = exports.WarningType || (exports.WarningType = {}));
/**
 * An enum that represents the validation status of an OpenAPI specification file.
 */
var ValidationStatus;
(function (ValidationStatus) {
    ValidationStatus[ValidationStatus["Valid"] = 0] = "Valid";
    ValidationStatus[ValidationStatus["Warning"] = 1] = "Warning";
    ValidationStatus[ValidationStatus["Error"] = 2] = "Error";
})(ValidationStatus = exports.ValidationStatus || (exports.ValidationStatus = {}));
//# sourceMappingURL=interfaces.js.map